var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              kamitaku: true,
              isDisabled: _vm.reqLoading,
              propsData: { isCurrency: true }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClickNew }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                }
              ],
              ref: "tableRef",
              attrs: {
                id: "tableRef",
                data: _vm.tableData,
                "cell-class-name": _vm.cellStyle,
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  "class-name": "font-bold",
                  prop: "date",
                  label: _vm.$t("date"),
                  width: _vm.$utils.flexColumnWidth("2021-01-01", true)
                }
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "new_account_num",
                  label: _vm.$t("registerNumColumnText"),
                  width: _vm.$utils.flexColumnWidth(
                    _vm.$t("registerNumColumnText"),
                    true
                  )
                }
              }),
              _vm._l(_vm.Dynamic, function(item, index) {
                return _c("el-table-column", {
                  key: "key" + index,
                  attrs: {
                    prop: item.prop,
                    label: item.label,
                    "render-header": function(h, obj) {
                      return _vm.renderheader(h, obj, item.desc)
                    },
                    width: _vm.$utils.flexColumnWidth(item.label + "2", false)
                  }
                })
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }